import React, {Component} from "react";
import {
    ADD_INSTRUMENT_ROUTE,
    CONTROL_PANEL_CAPTURE_GUARANTEE,
    CONTROL_PANEL_ROUTE
} from "../../../utils/constants/RoutesConstants";
import CaptureGuarantee from "./CaptureGuaranteeView";
import {MoveGuaranteeService} from "../../../service/controlPanel/MoveGuaranteeService";
import {amountCalculate} from "../../../utils/formatters/Numbers";
import {Growl} from "primereact/growl";
import ConfirmationMessage from "../../../components/confirmationMessage";

export default class CaptureGuaranteeContainer extends Component {
    constructor(props) {
        super(props);

        this.moveGuaranteeService = new MoveGuaranteeService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveAccountTrade = this.saveAccountTrade.bind(this);
        this.setGuaranteePA = this.setGuaranteePA.bind(this);
        this.redirectAddInstrument = this.redirectAddInstrument.bind(this);
        this.openConfirmationReject = this.openConfirmationReject.bind(this);
        this.rejectButton = this.rejectButton.bind(this);
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };


        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanId: this.props.location.state.folio,
            status: this.props.location.state.status,
            loanAmount: this.props.location.state.loanAmount,
            maturity: this.props.location.state.maturity,
            catAccount: '',
        };

        this.guaranteeInAccount = React.createRef();
        this.loanData = React.createRef();
    };

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    async componentDidMount() {
        await this.loanData.current.getLoan();
        await this.loanData.current.getRestrictionsLoan(this.state.loanId);
        await this.guaranteeInAccount.current.setLoanAmount(this.loanData.current.state.amount);
    }


    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message: message
        });
    }

    redirectAddInstrument() {
        this.props.history.push({
            pathname: ADD_INSTRUMENT_ROUTE,
            state: {
                returnPath: CONTROL_PANEL_CAPTURE_GUARANTEE,
                callScreen: "controlPanel",
                addGuarantee: true,
                loanId: this.state.loanId,
                account: this.state.catAccount.cuenta,
                loanAmount: this.loanData.current.state.amount,
                guaranteeAmount: this.guaranteeInAccount.current.state.guaranteeAmountTotal,
                selectedLoan: this.state.selectedLoan,
                maturity: this.state.maturity,
                status: this.state.status,
            },
        });
    }

    setGuaranteePA() {

        if (
            this.loanData.current.state.amount >
            amountCalculate(this.guaranteeInAccount.current.state.guaranteeAmountTotal)) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
        } else {
            this.loading(true)
            let arrayGuarantee = [];
            this.guaranteeInAccount.current.state.guaranteeList.map(
                (item) => {
                    if (item.newTitles && item.newTitles > 0) {
                        arrayGuarantee.push({
                            idEmisora: item.idEmisora,
                            titulos: item.newTitles,
                            idOperacion: 1
                        });
                    }
                    return '';
                });
            this.moveGuaranteeService.setGuaranteePA(
                this.state.loanId,
                this.state.catAccount.cuenta,
                this.state.status,
                arrayGuarantee
            ).then(response => {
                this.loading(false);
                if (response.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'Las garantías han sido guardadas exitosamente',
                    });
                }
            });
        }
    }

    saveAccountTrade(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,});

        this.guaranteeInAccount.current.setAccount(value.cuenta);
    }

    rejectButton() {
        this.moveGuaranteeService.rejectBorrowerPA(this.state.loanId, '', this.state.status).then(
            response => {
                if (response.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'El préstamo se ha rechazado exitosamente',
                    });

                }
            });
    }

    openConfirmationReject() {
        if (this.confirmationRef) {
            this.confirmationRef.openConfirmationMessage();
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro que desea rechazar este préstamo?"
                                           action={this.rejectButton}/>;

        return <CaptureGuarantee
            isLoading={this.state.isLoading}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            guaranteeInAccount={this.guaranteeInAccount}
            loanData={this.loanData}
            handleReturnButton={this.handleReturnButton}
            setGuaranteePA={this.setGuaranteePA}
            saveAccountTrade={this.saveAccountTrade}
            selectedLoan={this.state.selectedLoan}
            loanId={this.state.loanId}
            maturity={this.state.maturity}
            loanAmount={this.state.loanAmount}
            catAccount={this.state.catAccount}
            redirectAddInstrument={this.redirectAddInstrument}
            confirmationMessage={confMsg}
            openConfirmationReject={this.openConfirmationReject}
        />

    }
};